import { Table, StatusBadge, Card } from '@components/ui';
import { Wallet, TrendingUp, TrendingDown } from 'lucide-react';

export default function PaymentsTable({ data, onRowClick }) {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0,
        }).format(amount);
    };

    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    const columns = [
        {
            key: 'date',
            header: 'Tarih',
            width: 'md',
            render: (val) => formatDate(val),
        },
        {
            key: 'type',
            header: 'Tip',
            width: 'sm',
            align: 'center',
            render: (val) => (
                <StatusBadge
                    status={val === 'income' ? 'Gelir' : 'Gider'}
                    variant={val === 'income' ? 'success' : 'error'}
                />
            ),
        },
        {
            key: 'category',
            header: 'Kategori',
            width: 'md',
        },
        {
            key: 'description',
            header: 'Açıklama',
            width: 'lg',
            render: (val) => (
                <span className="text-text-secondary truncate max-w-[200px] block">
                    {val}
                </span>
            ),
        },
        {
            key: 'amount',
            header: 'Tutar',
            width: 'md',
            align: 'right',
            render: (val, row) => (
                <span className={row.type === 'income' ? 'text-success font-medium' : 'text-error font-medium'}>
                    {row.type === 'income' ? '+' : '-'}{formatCurrency(val)}
                </span>
            ),
        },
    ];

    // Mobile Card View
    const MobileCardView = () => (
        <div className="space-y-3 md:hidden">
            {data.length === 0 ? (
                <div className="text-center py-12 text-text-tertiary">
                    <Wallet size={40} className="mx-auto mb-2 opacity-50" />
                    <p>Henüz ödeme kaydı yok.</p>
                </div>
            ) : (
                data.map((row) => (
                    <div
                        key={row.id}
                        onClick={() => onRowClick?.(row)}
                        className="bg-bg-secondary rounded-lg border border-border-light p-4 active:scale-[0.99] cursor-pointer hover:border-primary/30 transition-all"
                    >
                        <div className="flex items-start justify-between gap-3">
                            <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${row.type === 'income' ? 'bg-success-100' : 'bg-error-100'
                                    }`}>
                                    {row.type === 'income' ? (
                                        <TrendingUp size={20} className="text-success" />
                                    ) : (
                                        <TrendingDown size={20} className="text-error" />
                                    )}
                                </div>
                                <div className="min-w-0">
                                    <p className="font-medium text-text-primary truncate">{row.category}</p>
                                    <p className="text-xs text-text-tertiary">{formatDate(row.date)}</p>
                                </div>
                            </div>
                            <div className="text-right shrink-0">
                                <p className={`font-bold ${row.type === 'income' ? 'text-success' : 'text-error'}`}>
                                    {row.type === 'income' ? '+' : '-'}{formatCurrency(row.amount)}
                                </p>
                                <StatusBadge
                                    status={row.type === 'income' ? 'Gelir' : 'Gider'}
                                    variant={row.type === 'income' ? 'success' : 'error'}
                                    size="xs"
                                />
                            </div>
                        </div>
                        {row.description && (
                            <p className="text-sm text-text-muted mt-2 truncate">{row.description}</p>
                        )}
                    </div>
                ))
            )}
        </div>
    );

    return (
        <>
            {/* Mobile Card View */}
            <MobileCardView />

            {/* Desktop Table View */}
            <div className="hidden md:block">
                <Table
                    columns={columns}
                    data={data}
                    onRowClick={onRowClick}
                    showRowNumbers
                    emptyMessage="Henüz ödeme kaydı yok."
                    emptyIcon={<Wallet size={40} />}
                />

            </div>
        </>
    );
}

